import React, { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import { toast } from 'react-toastify';
import axios from '../../api/axios';
import { 
  Button, 
  Col, 
  Form, 
  Row, 
  Spinner, 
  Table, 
  Container,
  Card,
  InputGroup,
  FormControl,
  Badge,
  Pagination,
  Modal
} from 'react-bootstrap';
// import { FaPrint, FaFileExport, FaSearch } from 'react-icons/fa';
import { Printer, FileEarmarkArrowUp , Search, FileEarmarkSpreadsheet, ArrowLeft } from 'react-bootstrap-icons';
import Header from '../../layouts/Header';
import { useNavigate } from 'react-router-dom';

const CouponsReport = () => {

    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const navigate = useNavigate();

    const accessToken = localStorage.getItem('authToken');
    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [outlets, setOutlets] = useState([]);
    const [selectedOutlet, setSelectedOutlet] = useState('');
    const [selectedOutletName, setSelectedOutletName] = useState('')
    const [error, setError] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [downloadBtnLoading, setDownloadBtnLoading] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const [clicked, setClicked] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(50);
    const [showExportModal, setShowExportModal] = useState(false);
    const [exportFormat, setExportFormat] = useState('excel');
  
    // Calculate pagination variables
    const totalPages = Math.ceil(filteredData?.length / recordsPerPage);
    const currentRecords = filteredData?.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );

    const getOutlets = async () => {
        try {
        const headers = {
            Authorization: `Bearer ${accessToken}`,
        };
        const response = await axios.get("outlet", { headers });

        if (response?.data?.status === true) {
            const activeOutlets = response?.data?.data?.outlets.filter((active) => active?.status === "ACTIVE" || "INACTIVE");
            setOutlets(activeOutlets);
        }
        } catch (error) {
        if (error?.response) {
            let errorMessage = "";
            if (error.response?.status === 406) {
            errorMessage =
                error?.response?.data?.error?.message ||
                error?.response?.data?.error;
            } else if (error.response?.status === 412) {
            errorMessage = error?.response?.data?.data?.message;
            } else if (error.response?.status === 500) {
            errorMessage = error?.response?.data?.error;
            }

            toast.error(errorMessage, {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
            });
        }
        }
    };

  const getCouponsData = async (start, end, outlet, search, download) => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
        "content-type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      };

      const updatedStartDate = start ? start.toISOString().split("T")[0] : null;
      const updatedEndDate = end ? end.toISOString().split("T")[0] : null;

      let apiUrl = `coupons/report/getAllCouponUsageReport?startDate=${updatedStartDate}&endDate=${updatedEndDate}`;

      // Append optional query parameters dynamically
      const queryParams = {
        outlet,
        search,
        isDownload: download
      };

      Object.entries(queryParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          apiUrl += `&${key}=${value}`;
        }
      });

      // Set responseType 'blob' for file download
      const response = await axios.get(apiUrl, { headers, responseType: download ? 'blob' : 'json' });

      if (download) {
        const blob = new Blob([response.data], { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${selectedOutletName} Coupon Usage Report (${updatedStartDate} - ${updatedEndDate}).xlsx`);
        document.body.appendChild(link);
        link.click();

        // Clean up
        link.remove();
        window.URL.revokeObjectURL(url);

        toast.success('Excel file downloaded successfully!', {
          position: "top-right",
          autoClose: 3000,
          theme: "light"
        });
      } else {
        if (response?.data?.status === true) {
          setFilteredData(response?.data?.data?.dbResponse);
          setClicked(true);
          toast.success(response?.data?.message, {
            position: "top-right",
            autoClose: 3000,
            theme: "light"
          });
        }
      }
    } catch (error) {
      console.error("Error in coupon data fetch:", error);

      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
        });
      }
    } finally {
      setDownloadBtnLoading(false);
      setSubmitBtnLoading(false);
    }
  };  

  const handleEndDateChange = (date) => {
    if (date && startDate) {
  const start = new Date(startDate).setHours(0, 0, 0, 0);
  const end = new Date(date).setHours(0, 0, 0, 0);

  if (end < start) {
    setError('End date cannot be earlier than start date');
  } else {
    setError('');
    setEndDate(date);
  }
}
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitBtnLoading(true);
    setCurrentPage(1);

    const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
    const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));

    await getCouponsData(adjustedStartDate, adjustedEndDate, selectedOutlet, searchText);
  };

  const handleDownloadExcel = async () => {
    setDownloadBtnLoading(true);
    const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
    const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
    getCouponsData(adjustedStartDate, adjustedEndDate, selectedOutlet, searchText, true);
  };

  const handlePrintReport = () => {
    const tableContent = `
      <table style="border-collapse: collapse; width: 100%;">
        <thead>
          <tr>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Sr.No</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Coupon Code</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Coupon Title</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Usage Count</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Sales Contribution</th>
            <th style="border: 1px solid black; padding: 8px; text-align: center;">Discount Given</th>
            <th style="border: 1px solid black; padding: 8px; text-align: center;">Avg. Discount</th>
          </tr>
        </thead>
        <tbody>
          ${filteredData?.length > 0 ? 
            filteredData?.map((coupon, index) => `
              <tr>
                <td style="border: 1px solid black; padding: 8px; font-size: 13px">${index + 1}</td>
                <td style="border: 1px solid black; padding: 8px; font-size: 13px;">${coupon?.couponCode}</td>
                <td style="border: 1px solid black; padding: 8px; font-size: 13px;">${coupon?.title}</td>
                <td style="border: 1px solid black; padding: 8px; font-size: 13px; text-align: center">${coupon?.usageCount}</td>
                <td style="border: 1px solid black; padding: 8px; font-size: 13px; text-align: end">₹. ${coupon?.salesContribution?.toFixed(2)}</td>
                <td style="border: 1px solid black; padding: 8px; font-size: 13px; text-align: end">₹. ${coupon?.discountGiven?.toFixed(2)}</td>
                <td style="border: 1px solid black; padding: 8px; font-size: 13px; text-align: end">₹. ${coupon?.avgDiscount?.toFixed(2)}</td>
              </tr>
            `).join("") :
            `<tr>
              <td colspan="7" style="border: 1px solid black; padding: 8px; text-align: center;">No Coupons Found</td>
            </tr>`
          }
        </tbody>
      </table>
    `;

    const win = window.open("", "", "width=900,height=600");
    win.document.write(`
      <html>
        <head>
          <title>Coupons Report</title>
          <style>
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid black; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; }
          </style>
        </head>
        <body onload="window.print();window.close()">
          <h2>Coupons Report</h2>
          <div>${tableContent}</div>
        </body>
      </html>
    `);
    win.document.close();
  };

  const renderPaginationItems = () => {
    const items = [];
    const maxVisiblePages = 5;
    let startPage, endPage;

    if (totalPages <= maxVisiblePages) {
      startPage = 1;
      endPage = totalPages;
    } else {
      const maxVisibleBeforeCurrent = Math.floor(maxVisiblePages / 2);
      const maxVisibleAfterCurrent = Math.ceil(maxVisiblePages / 2) - 1;
      
      if (currentPage <= maxVisibleBeforeCurrent) {
        startPage = 1;
        endPage = maxVisiblePages;
      } else if (currentPage + maxVisibleAfterCurrent >= totalPages) {
        startPage = totalPages - maxVisiblePages + 1;
        endPage = totalPages;
      } else {
        startPage = currentPage - maxVisibleBeforeCurrent;
        endPage = currentPage + maxVisibleAfterCurrent;
      }
    }

    if (startPage > 1) {
      items.push(
        <Pagination.Item key={1} active={1 === currentPage} onClick={() => handlePageChange(1)}>
          1
        </Pagination.Item>
      );
      if (startPage > 2) {
        items.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      items.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i}
        </Pagination.Item>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        items.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }
      items.push(
        <Pagination.Item 
          key={totalPages} 
          active={totalPages === currentPage} 
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    getOutlets();
  }, []);

  useEffect(() => {
    if(searchText === "" && isTyping) {
      const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
      const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
      getCouponsData(adjustedStartDate, adjustedEndDate, selectedOutlet, searchText)
    }
  }, [searchText]);

  useEffect(() => {
    const now = new Date();
    const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const currentDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );

    const start = new Date(firstOfMonth.setHours(23, 59, 59, 999));
    const end = new Date(currentDate.setHours(23, 59, 59, 999));
    setStartDate(start);
    setEndDate(end);
  }, []);

  return (
    <React.Fragment>
        <Header onSkin={setSkin} />
        <div className="main main-app p-3 p-lg-4">
            <Card className="shadow-sm border-0">
            <Card.Header className="bg-white border-0">
                <div className="card-header bg-white border-0 py-1 d-flex justify-content-between align-items-center">
                  <div>
                      <h4 className="mb-0 fw-bold d-inline-block">
                          <i className="bi bi-ticket-perforated me-2"></i>COUPONS REPORT
                      </h4>
                  </div>
                  <div>
                      <Button 
                          variant="outline-secondary" 
                          size="sm" 
                          onClick={() => navigate('/reports/all-reports')}
                          className="me-3 d-flex align-items-center fw-semibold"
                          style={{ height: '38px' }}
                      >
                          <ArrowLeft className="me-1" /> Back to Reports
                      </Button>
                  </div>
              </div>
            </Card.Header>
            <hr className='mt-0 mb-0' />
            
            <Card.Body>
                {/* Filters Section */}
                <div className="p-3 bg-light rounded-3">
                <Form onSubmit={handleSubmit}>
                    <Row className="g-3">
                      <Col md={4} lg={6} sm={4}>
                          <Form.Group controlId="outletSelect">
                          <Form.Label className="fw-semibold">
                              <i className="bi bi-shop me-2"></i>Outlet
                          </Form.Label>
                          <Form.Select
                              value={selectedOutlet}
                              onChange={(e) => 
                                {
                                  setSelectedOutlet(e.target.value)
                                  setSelectedOutletName(e.target.selectedOptions[0].label)
                                }
                              }
                              className="border-secondary"
                          >
                              <option value="">All Outlets</option>
                              {outlets?.map((outlet) => (
                              <option key={outlet?._id} value={outlet?._id} label={`${outlet?.name} (${outlet?.city})`}>
                                  {outlet?.name}
                              </option>
                              ))}
                          </Form.Select>
                          </Form.Group>
                      </Col>

                      {/* <Col md={2} lg={2} sm={4}>
                          <Form.Group controlId="startDate">
                          <Form.Label className="fw-semibold">
                              <i className="bi bi-calendar me-2"></i>Start Date
                          </Form.Label>
                          <DatePicker
                              selected={startDate}
                              onChange={(date) => setStartDate(date)}
                              dateFormat="dd-MM-yyyy"
                              placeholderText="Start Date"
                              className="form-control border-secondary"
                          />
                          </Form.Group>
                      </Col>

                      <Col md={2} lg={2} sm={4}>
                          <Form.Group controlId="endDate">
                          <Form.Label className="fw-semibold">
                              <i className="bi bi-calendar me-2"></i>End Date
                          </Form.Label>
                          <DatePicker
                              selected={endDate}
                              onChange={handleEndDateChange}
                              dateFormat="dd-MM-yyyy"
                              placeholderText="End Date"
                              className="form-control border-secondary"
                              minDate={startDate}
                          />
                          {error && <div className="text-danger small mt-1">{error}</div>}
                          </Form.Group>
                      </Col> */}

                      <Col md={2}>
                        <Form.Group controlId="startDate">
                          <Form.Label className="fw-semibold">
                            <i className="bi bi-calendar me-2"></i>Start Date
                          </Form.Label>
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => {
                              setStartDate(date);
                              // Reset endDate if it exceeds 60 days from the new startDate
                              if (endDate && date && endDate > new Date(date.getTime() + 60 * 24 * 60 * 60 * 1000)) {
                                setEndDate(null);
                              }
                            }}
                            dateFormat="dd-MM-yyyy"
                            className="form-control border-secondary"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={2}>
                        <Form.Group controlId="endDate">
                          <Form.Label className="fw-semibold">
                            <i className="bi bi-calendar me-2"></i>End Date
                          </Form.Label>
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => {
                              if (startDate && date > new Date(startDate.getTime() + 60 * 24 * 60 * 60 * 1000)) {
                                setError("End date cannot be more than 60 days after start date");
                              } else {
                                setError("");
                                handleEndDateChange(date);
                              }
                            }}
                            dateFormat="dd-MM-yyyy"
                            minDate={startDate}
                            maxDate={startDate ? new Date(startDate.getTime() + 60 * 24 * 60 * 60 * 1000) : null}
                            className="form-control border-secondary"
                          />
                          {error && <div className="text-danger small mt-1">{error}</div>}
                        </Form.Group>
                      </Col>


                      <Col md={3} lg={2} className="d-flex align-items-end">
                          <Button
                          variant="primary"
                          type="submit"
                          className="w-100"
                          disabled={!selectedOutlet || !startDate || !endDate || submitBtnLoading}
                          >
                          {submitBtnLoading ? (
                              <Spinner size="sm" animation="border" />
                          ) : (
                              "Generate Report"
                          )}
                          </Button>
                      </Col>
                    </Row>
                </Form>
                </div>

                {/* Search and Actions Section */}
                <div className="mb-4 p-3 bg-light rounded-3">
                <Row className="g-3 align-items-center">
                    <Col md={6}>
                    <InputGroup>
                        <FormControl
                        type="text"
                        placeholder="Search by coupon code"
                        value={searchText}
                        onChange={(e) => {
                            setIsTyping(true);
                            setSearchText(e.target.value);
                        }}
                        className="border-secondary"
                        />
                        <Button 
                        variant="outline-secondary"
                        onClick={handleSubmit}
                        disabled={!selectedOutlet || !startDate || !endDate || submitBtnLoading}
                        >
                        {submitBtnLoading ? (
                            <Spinner size="sm" animation="border" />
                        ) : (
                            <>
                            <Search className="me-2" />
                            Search
                            </>
                        )}
                        </Button>
                    </InputGroup>
                    </Col>
                    
                    {/* <Col md={3}>
                      <Button
                          variant="success"
                          className="w-100"
                          onClick={handlePrintReport}
                          disabled={!filteredData.length}
                      >
                          <Printer className="me-2" />
                          Print Report
                      </Button>
                    </Col> */}

                    <Col md={3}>
                    <Button
                        variant="outline-success"
                        className="w-100 fw-semibold"
                        // onClick={() => setShowExportModal(true)}
                        onClick={handleDownloadExcel}
                        disabled={!filteredData.length}
                    >
                        <FileEarmarkSpreadsheet className="me-2" />
                        {downloadBtnLoading ? <Spinner size='sm' animation='border' /> : "Download Excel"}
                    </Button>
                    </Col>
                </Row>
                </div>

                {/* Results Section */}
                {!clicked ? (
                  <div className="d-flex justify-content-center align-items-center py-5 my-5 bg-light rounded-3">
                      <div className="text-center">
                      <i className="bi bi-ticket-perforated fs-1 text-muted"></i>
                      <h5 className="text-muted mt-3">
                          Please select an outlet and date range to view coupons report
                      </h5>
                      </div>
                  </div>
                ) : (
                <>
                    {/* Pagination and Records Per Page - Top */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-center">
                        <span className="me-2 text-muted">Show</span>
                        <Form.Select
                        style={{ width: 'auto' }}
                        value={recordsPerPage}
                        onChange={(e) => setRecordsPerPage(Number(e.target.value))}
                        className="border-secondary"
                        >
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={200}>200</option>
                        <option value={300}>300</option>
                        <option value={500}>500</option>
                        </Form.Select>
                        <span className="ms-2 text-muted">entries</span>
                    </div>
                    
                    <Pagination className="mb-0">
                        <Pagination.Prev
                        disabled={currentPage === 1}
                        onClick={() => handlePageChange(currentPage - 1)}
                        />
                        {renderPaginationItems()}
                        <Pagination.Next
                        disabled={currentPage === totalPages}
                        onClick={() => handlePageChange(currentPage + 1)}
                        />
                    </Pagination>
                    </div>

                    {/* Coupons Table */}
                    <div className="table-responsive border rounded-3">
                    <Table striped bordered hover className="mb-0">
                        <thead className="bg-light">
                        <tr>
                            <th width="50">#</th>
                            <th>Coupon Code</th>
                            <th>Coupon Title</th>
                            <th width="100" className="text-center">Usage Count</th>
                            <th width="150" className="text-end">Sales Contribution</th>
                            <th width="150" className="text-end">Discount Given</th>
                            <th width="150" className="text-end">Avg. Discount</th>
                        </tr>
                        </thead>
                        <tbody>
                        {loading ? (
                            <tr>
                            <td colSpan="7" className="text-center py-4">
                                <Spinner animation="border" variant="primary" />
                                <p className="mt-2 mb-0">Loading coupons data...</p>
                            </td>
                            </tr>
                        ) : currentRecords?.length > 0 ? (
                            currentRecords.map((coupon, index) => (
                            <tr key={index}>
                                <td className="text-muted">
                                {(currentPage - 1) * recordsPerPage + index + 1}
                                </td>
                                <td className="fw-semibold text-primary">
                                {coupon?.couponCode || '-'}
                                </td>
                                <td>
                                {coupon?.title || '-'}
                                </td>
                                <td className="text-center">
                                <Badge bg="primary" pill>
                                    {coupon?.usageCount || 0}
                                </Badge>
                                </td>
                                <td className="text-end">
                                ₹ {coupon?.salesContribution?.toFixed(2) || '0.00'}
                                </td>
                                <td className="text-end">
                                ₹ {coupon?.discountGiven?.toFixed(2) || '0.00'}
                                </td>
                                <td className="text-end">
                                ₹ {coupon?.avgDiscount?.toFixed(2) || '0.00'}
                                </td>
                            </tr>
                            ))
                        ) : (
                            <tr>
                            <td colSpan="7" className="text-center py-4">
                                <i className="bi bi-exclamation-circle fs-4 text-muted"></i>
                                <p className="mt-2 mb-0 text-muted">
                                No coupons found for the selected criteria
                                </p>
                            </td>
                            </tr>
                        )}
                        </tbody>
                    </Table>
                    </div>

                    {/* Pagination and Records Per Page - Bottom */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                    <div className="text-muted">
                        Showing {(currentPage - 1) * recordsPerPage + 1} to{' '}
                        {Math.min(currentPage * recordsPerPage, filteredData?.length)} of{' '}
                        {filteredData?.length} entries
                    </div>
                    <Pagination>
                        <Pagination.Prev
                        disabled={currentPage === 1}
                        onClick={() => handlePageChange(currentPage - 1)}
                        />
                        {renderPaginationItems()}
                        <Pagination.Next
                        disabled={currentPage === totalPages}
                        onClick={() => handlePageChange(currentPage + 1)}
                        />
                    </Pagination>
                    </div>
                </>
                )}
            </Card.Body>
            </Card>

            {/* Export Modal */}
            <Modal show={showExportModal} onHide={() => setShowExportModal(false)} centered>
              <Modal.Header closeButton>
                  <Modal.Title>Export Coupons Report</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  <Form.Group className="mb-3">
                  <Form.Label>Select Export Format</Form.Label>
                  <Form.Select 
                      value={exportFormat}
                      onChange={(e) => setExportFormat(e.target.value)}
                  >
                      <option value="excel">Excel</option>
                      <option value="pdf">PDF</option>
                      <option value="csv">CSV</option>
                  </Form.Select>
                  </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowExportModal(false)}>
                  Cancel
                  </Button>
                  <Button variant="primary" onClick={handleDownloadExcel}>
                  {downloadBtnLoading ? (
                      <Spinner size="sm" animation="border" />
                  ) : (
                      "Export"
                  )}
                  </Button>
              </Modal.Footer>
            </Modal>
        </div>
    </React.Fragment>
  );
}

export default CouponsReport;